import Money from "./Money";
import RPMPass from "./RPMPass";

const Supplements = (props) => {
  return (
    <section className="supplements">
      <div className="container">
        <div className="supplements-wrapper">
          {props.rpmpass.products.length > 0 && <RPMPass rpmpass={props.rpmpass} />}
          {props.currency && <Money currency={props.currency} />}
        </div>
      </div>
    </section>
  );
};

export default Supplements;
